import { VisitTypeGeneratedEntity } from "./generated/VisitTypeGeneratedEntity";

export abstract class VisitTypeEntity extends VisitTypeGeneratedEntity {
    // Comment to preserve new line
}
